import WarningAmberIcon from "assets/icons/WarningAmberIcon";
import WarningIcon from "assets/icons/WarningIcon";
import Modal from "components/modals/TestModal";
import Button from "features/newLanding/Button/Button";

const WarningModal = ({
  open,
  onClick,
  heading,
  warningText,
  width = "200px",
  secondBtnText,
  secondBtnFn,
  closeOnOuterClick = false,
  warningCircle = true,
}) => {
  return (
    <Modal
      show={open}
      position="center"
      width={width}
      isEcomm={true}
      onClose={() => (closeOnOuterClick ? onClick() : undefined)}
    >
      <div className="flex flex-col gap-5 items-center pb-3 px-3">
        <div className="flex flex-col items-center gap-[5px] font-bold">
          {warningCircle ? <WarningIcon /> : <WarningAmberIcon />}
          <p className="text-sm text-center">{heading}</p>

          <p className="text-center text-xs font-normal">{warningText}</p>
        </div>

        <div className="flex w-full justify-center gap-36">
          {secondBtnText ? (
            <div className="flex items-center justify-between w-full px-12">
              <Button className="text-[#007AFF]" onClick={onClick}>
                Cancel
              </Button>
              <Button
                className="text-[#fd7271] font-bold"
                onClick={secondBtnFn}
              >
                {secondBtnText}
              </Button>
            </div>
          ) : (
            <Button className="text-[#007AFF] font-bold" onClick={onClick}>
              OK
            </Button>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default WarningModal;
